import type { BrowserClient, EventHint, Scope } from '@sentry/browser';
import { withScope as withScopeFromSentry } from '@sentry/browser';
import { getClientFor } from './getClientFor';
import { getContexts } from './getContexts';
import type { AppContext } from './types/AppContext';
import { defaultAppContext } from '.';

type ReportErrorDependencies = {
  appContext?: AppContext;
  client?: BrowserClient;
  location?: Location;
  navigator?: Navigator;
  withScope?: typeof withScopeFromSentry;
};

export const reportError =
  ({
    client = getClientFor(),
    appContext = defaultAppContext,
    location = window.location,
    navigator = window.navigator,
    withScope = withScopeFromSentry,
  }: ReportErrorDependencies) =>
  (error: unknown, hint?: EventHint): void => {
    withScope((scope: Scope) => {
      scope.setTransactionName(`${appContext.app_name}@${location.host}`);

      if (hint?.data?.user) {
        scope.setUser(hint.data.user);
      }

      scope.setContext('app', appContext);

      Object.entries(getContexts(navigator, location)).forEach(
        ([key, value]) => {
          scope.setContext(key, value);
        },
      );

      client.captureException(error, hint, scope);
    });
  };
